import React from 'react';
import Image from 'next/image';
import { useTranslations } from 'next-intl';

import { TimeAgo } from 'modules/global';

interface IProps {
  courseName?: string;
  userName?: string;
  userImage?: string;
  createdAt?: number;
  slug?: string;
}

const CourseAvatar: React.FC<IProps> = ({ courseName, userImage, userName, createdAt }) => {
  const t = useTranslations();

  return (
    <div className="flex items-start gap-2">
      <div className="flex min-h-8 min-w-8 max-w-8 max-h-8 items-center justify-center overflow-hidden rounded-full border border-gray-200 bg-gray-50">
        <Image
          src={userImage || '/images/default-no-logo.webp'}
          alt={userName?.slice(0, 1) || 'user profile avatar'}
          width={userImage ? 35 : 18}
          height={userImage ? 35 : 18}
          className="object-contain "
          title="Kurs ishlab chiquvchining rasmi"
        />
      </div>
      <div className="flex h-14 flex-col justify-between">
        <div className="flex flex-col">
          <span className="line-clamp-2 text-xs font-medium">{courseName}</span>
          <span className="line-clamp-1 text-[0.625rem] text-gray-500">{userName}</span>
        </div>
        <span className="text-[0.625rem] text-gray-500">
          {TimeAgo(createdAt)} {t('qoshilgan')}
        </span>
      </div>
    </div>
  );
};

export default CourseAvatar;
